
import { defineComponent } from 'vue';

// Components
import SearchButton from '@/components/Button/SearchButton.vue';

export default defineComponent({
  name: 'SearchBar',
  components: {
    SearchButton
  },
  inheritAttrs: false,
  data() {
    return {
      inputFocused: false
    };
  },
  props: {
    placeholder: {
      type: String
    },
    value: {
      type: String,
      required: true
    }
  },
  emits: ['update:value'],
  methods: {
    setFocused() {
      this.inputFocused = true;
    },
    setUnfocused() {
      this.inputFocused = false;
    }
  }
});
